import { render, staticRenderFns } from "./DataAuditor.vue?vue&type=template&id=854c8560&scoped=true&"
import script from "./DataAuditor.vue?vue&type=script&lang=js&"
export * from "./DataAuditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854c8560",
  null
  
)

export default component.exports